/* eslint-disable @typescript-eslint/no-explicit-any */
import Pocketbase, { RecordService, type AuthProviderInfo } from 'pocketbase'
import { getFormData } from './helpers'
import { env } from '$env/dynamic/public'
import type { Collections, TypedPocketBase, UsersResponse } from './pocketbase-types'

export const adminPb = new Pocketbase(env.PUBLIC_PB_URL) as TypedPocketBase
adminPb.autoCancellation(false)

export async function save(collection: Collections, record: any, create = false, pb: TypedPocketBase) {
  const data = getFormData(record)
  if (record.id && !create) {
    return await pb.collection(collection).update(record.id, data)
  } else {
    return await pb.collection(collection).create(data)
  }
}

export async function providerLogin(provider: AuthProviderInfo, authCollection: RecordService, pb: TypedPocketBase) {
  const w = window.open()

  const authResponse = await pb.collection('users').authWithOAuth2({
    provider: provider.name,
    urlCallback: (url) => {
      w!.location.href = url
    },
    createData: {
      emailVisibility: true
    }
  })

  const { meta, record } = authResponse
  const changes = {} as { [key: string]: any }

  if (!record.name && meta?.rawUser && meta.rawUser?.given_name) {
    changes.name = meta.rawUser.given_name
  }

  if (!record.last_name && meta?.rawUser && meta.rawUser?.family_name) {
    changes.last_name = meta.rawUser.family_name
  }

  if (!record.name && !changes.name && meta?.name) {
    changes.name = meta.name
  }

  if (Object.keys(changes).length) {
    authResponse.record = (await save(authCollection.collectionIdOrName as Collections, {
      ...record,
      ...changes
    }, false, pb)) as UsersResponse<unknown>
  }

  const cookieContent = pb.authStore.exportToCookie({ httpOnly: false })
  if (typeof document !== 'undefined' && typeof window !== 'undefined') {
    document.cookie = cookieContent

    window.location.href = '/'
  }
}
